import { axiosRequest } from '../../utils/Requests.js';

export default {
    props: [ 'imobiliaria' ],
    data() {
      return {
        mensagem: {
          cliente: "",
          telefone: "",
          email: "",
          texto: ""
        },
        showToast: false,
        toastTitle: "",
        toastVariant: "",
        toastMessage: "",
      }
    },
    computed: {
      isVisibleMapa() {
        return this.imobiliaria.urlMapaEstatico !== null;
      },
      nomeImobiliaria() { return this.imobiliaria.nome },
    },
    mounted() {
      document.title = "Anuncie Aqui | " + this.imobiliaria.nome
    },
    methods: {
      enviarMensagem() {
        // 1. Validação: Verifica se algum campo obrigatório está vazio
        if (!this.mensagem.cliente || !this.mensagem.telefone || !this.mensagem.email || !this.mensagem.texto) {
          this.showToast = true;
          this.toastTitle = "Atenção";
          this.toastVariant = "warning";
          this.toastMessage = "Por favor, preencha todos os campos antes de enviar.";
          return; // Interrompe a função aqui, não enviando nada para o servidor
        }

        // 2. Requisição: Dispara para o backend se a validação passar
        axiosRequest.post("/enviarMensagem", this.mensagem)
        .then((resultado) => {
          // Sucesso Real: Limpa os campos
          this.mensagem.cliente = "";
          this.mensagem.telefone = "";
          this.mensagem.email = "";
          this.mensagem.texto = "";
          
          // Exibe o Toast de Sucesso para o usuário
          this.showToast = true;
          this.toastTitle = "Sucesso";
          this.toastVariant = "success";
          this.toastMessage = "Sua mensagem foi enviada com sucesso!";

          // Mantido do seu código original (verifica se existe antes de chamar para evitar bugs)
          if (typeof this.setData === 'function') {
            this.setData(resultado.data);
          }
          
        }).catch((erro) => {
          // Erro Real: Caso o servidor falhe ou a internet caia
          this.showToast = true;
          this.toastTitle = "Erro";
          this.toastVariant = "danger"; // Usa a cor vermelha do Bootstrap-Vue
          this.toastMessage = "Não foi possível enviar sua mensagem. Tente novamente mais tarde.";
          
          console.error("Erro ao enviar anúncio de imóvel: ", erro);
        });
      }
    }
}